import { IHeaderParams, SortDirection } from "ag-grid-community";
import React, { MouseEventHandler } from "react";
import { ReactComponent as ArrowDownRegularIcon } from "../../assets/icons/arrow-down-regular.svg";
import { ReactComponent as ArrowUpRegularIcon } from "../../assets/icons/arrow-up-regular.svg";
import { TReceiptEntity } from "../../types/billing";
import { track } from "../../utils/tracking";

type HeaderProps = IHeaderParams<TReceiptEntity>;

const SortHeaderComponent = ({ displayName, column, setSort }: HeaderProps) => {
  const [sortStatus, setSortStatus] = React.useState<"no" | "asc" | "desc">(
    "no"
  );

  const onSortChanged = () => {
    const isAsc = column.isSortAscending();
    const isDesc = column.isSortDescending();

    setSortStatus(isAsc ? "asc" : isDesc ? "desc" : "no");
  };

  React.useEffect(() => {
    column.addEventListener("sortChanged", onSortChanged);
    onSortChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSortRequested = (
    order: SortDirection,
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    setSort(order, event.shiftKey);
  };

  const handleHeaderClick: MouseEventHandler<HTMLDivElement> = (e) => {
    let newSortType: SortDirection = null;
    if (sortStatus === "no") {
      newSortType = "asc";
    } else if (sortStatus === "asc") {
      newSortType = "desc";
    }
    const colId = column.getColId();
    track("SORT", { by: colId, type: newSortType || "" });
    onSortRequested(newSortType, e);
  };

  return (
    <div
      className="flex justify-between items-center uppercase text-11 text-neutral-4 font-700 w-full"
      onClick={handleHeaderClick}
    >
      <div>{displayName}</div>
      {sortStatus === "asc" && (
        <ArrowDownRegularIcon className="w-16 h-16 text-neutral-4" />
      )}
      {sortStatus === "desc" && (
        <ArrowUpRegularIcon className="w-16 h-16 text-neutral-4" />
      )}
    </div>
  );
};

export default SortHeaderComponent;
